import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  addButtonContainer: {
    display: "flex",
    justifyContent: "flex-end"
  },
  tableHead: {
    height: "45px"
  },
  headCells: {
    border: "none",
    borderBottom: "none",
    color: theme.tables.headerCell.color,
    fontWeight: theme.tables.headerCell.fontWeight,
    fontFamily: theme.tables.headerCell.fontFamily,
    lineHeight: theme.tables.headerCell.lineHeight,
    letterSpacing: theme.tables.headerCell.letterSpacing,
    backgroundColor: theme.tables.headerCell.backgroundColor,
    textTransform: theme.tables.headerCell.textTransform,
    height: 45,
    fontSize: 13
  },
  rowCell: {
    fontFamily: theme.tables.tableCell.fontFamily,
    color: theme.tables.tableCell.color,
    fontSize: theme.tables.tableCell.fontSize,
    padding: theme.tables.tableCell.padding
  },
  paperPadding: {
    padding: "20px 21px",
    // Stretches to the viewport (same pattern as AuditsList.style.ts) so the
    // card doesn't just shrink to its content height.
    height: "calc(100vh - 210px)",
    display: "flex",
    flexFlow: "column nowrap",
    marginTop: "20px",
    overflowX: "hidden",
    overflowY: "auto",
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  searchField: {
    width: "300px",
    marginRight: "40px"
  },
  tableContainer: {
    height: "100%",
    width: "100%"
  }
}));

export default useStyles;
